export default {
  baRecepention: 'Ba Penerimaan',
  baspDatabase: 'Database BA Penerimaan',
  reasonBasp: 'Alasan BA Penerimaan',
  needShipper: 'Perlu Konfirmasi Shipper',
  freeText: 'Free Text',
  aktif: 'Aktif',
  edit: 'Ubah',
  searchText: 'Cari Alasan BA Penerimaan',
  titleForEdit: 'Ubah Alasan BA Penerimaan',
  titleForCreate: 'Buat Alasan BA Penerimaan'
}
